import { CurrencyBalanceAttributes } from '@loyalty/shared-common/profile-api-client';
import { LevelAttributes } from './index';

export function computeAmountUntilNextLevel(
  currentLevel: LevelAttributes | undefined,
  nextLevel: LevelAttributes | undefined,
  currencyBalance: CurrencyBalanceAttributes | undefined,
): { current: number; total: number } {
  const total = Math.max(
    (nextLevel?.minCurrencyAmount ?? 0) - (currentLevel?.minCurrencyAmount ?? 0),
    0,
  );
  return {
    current: Math.min(
      Math.max(
        (currencyBalance?.totalOverLevelPeriod ?? 0) - (currentLevel?.minCurrencyAmount ?? 0),
        0,
      ),
      total,
    ),
    total,
  };
}
